<template>
  <div class="wrapper">
    <parallax
      :style="headerStyle"
      class="section page-header header-filter"
    ></parallax>
    <div class="main main-raised-top">
      <div class="section profile-content">
        <div class="container">
          <div class="profile-tabs">
            <tabs
              :tab-icon="['memory', 'developer_board', 'devices_other']"
              :tab-name="['工业光端机', '工业交换机', '汇聚交换机']"
              color-button="success"
              nav-pills-icons
              plain
            >
              <template slot="tab-pane-1">
                <div class="md-layout">
                  <!--                  <div class="md-layout-item md-size-medium ml-auto">-->
                  <!--                    <img :src="tabPane1[2].image" class="rounded" />-->
                  <!--                    <img :src="tabPane1[2].image" class="rounded" />-->
                  <!--                  </div>-->
                  <!--                  <div class="md-layout-item md-size-medium mr-auto">-->
                  <!--                    <img :src="tabPane1[2].image" class="rounded" />-->
                  <!--                    <img :src="tabPane1[2].image" class="rounded" />-->
                  <!--                  </div>-->
                  <!--                  <div class="md-layout-item md-size-medium mr-auto">-->
                  <!--                    <img :src="tabPane1[2].image" class="rounded" />-->
                  <!--                    <img :src="tabPane1[2].image" class="rounded" />-->
                  <!--                  </div>-->
                  <h4>升级维护中</h4>
                </div>
              </template>
              <template slot="tab-pane-2">
                <div class="md-layout">
                  <!--                  <div class="md-layout-item md-size-medium ml-auto">-->
                  <!--                    <img :src="tabPane2[0].image" class="rounded" />-->
                  <!--                  </div>-->
                  <!--                  <div class="md-layout-item md-size-medium ml-auto">-->
                  <!--                    <img :src="tabPane2[0].image" class="rounded" />-->
                  <!--                  </div>-->
                  <!--                  <div class="md-layout-item md-size-medium ml-auto">-->
                  <!--                    <img :src="tabPane2[0].image" class="rounded" />-->
                  <!--                  </div>-->
                  <h4>升级维护中</h4>
                </div>
              </template>
              <template slot="tab-pane-3">
                <div class="md-layout">
                  <!--                  <div class="md-layout-item md-size-medium ml-auto">-->
                  <!--                    <img :src="tabPane3[0].image" class="rounded" />-->
                  <!--                    <img :src="tabPane3[1].image" class="rounded" />-->
                  <!--                  </div>-->
                  <!--                  <div class="md-layout-item md-size-medium mr-auto">-->
                  <!--                    <img :src="tabPane3[2].image" class="rounded" />-->
                  <!--                    <img :src="tabPane3[3].image" class="rounded" />-->
                  <!--                    <img :src="tabPane3[4].image" class="rounded" />-->
                  <!--                  </div>-->
                  <h4>升级维护中</h4>
                </div>
              </template>
            </tabs>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Tabs } from "@/components";

export default {
  components: {
    Tabs
  },
  bodyClass: "profile-page",
  data() {
    return {
      tabPane1: [
        { image: require("@/assets/img/tx/8000e.png") },
        { image: require("@/assets/img/examples/studio-2.jpg") },
        { image: require("@/assets/img/examples/studio-4.jpg") },
        { image: require("@/assets/img/examples/studio-5.jpg") }
      ],
      tabPane2: [
        { image: require("@/assets/img/tx/8000e.png") },
        { image: require("@/assets/img/examples/clem-onojeghuo.jpg") },
        { image: require("@/assets/img/examples/cynthia-del-rio.jpg") },
        { image: require("@/assets/img/examples/mariya-georgieva.jpg") },
        { image: require("@/assets/img/examples/clem-onojegaw.jpg") }
      ],
      tabPane3: [
        { image: require("@/assets/img/tx/5d532.png") },
        { image: require("@/assets/img/examples/studio-3.jpg") },
        { image: require("@/assets/img/examples/clem-onojeghuo.jpg") },
        { image: require("@/assets/img/examples/olu-eletu.jpg") },
        { image: require("@/assets/img/examples/studio-1.jpg") }
      ]
    };
  },
  props: {
    header: {
      type: String,
      default: require("@/assets/img/fiber.jpg")
    }
  },
  computed: {
    headerStyle() {
      return {
        backgroundImage: `url(${this.header})`
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.section {
  padding: 0;
}

.profile-tabs::v-deep {
  .md-card-tabs .md-list {
    justify-content: center;
  }

  [class*="tab-pane-"] {
    margin-top: 3.213rem;
    padding-bottom: 50px;

    img {
      margin-bottom: 2.142rem;
    }
  }
}
</style>
